import { OrderStatusEnum } from "@/config/apiClient.types";
import { tolgee } from "@/providers/TranslationProvider";

export const getOrderBadgeStatusText = (status?: string) => {
  switch (status) {
    case OrderStatusEnum.CANCELLED:
      return tolgee.t("badgeStatus.order_CANCELLED");
    case OrderStatusEnum.DONE:
      return tolgee.t("badgeStatus.order_DONE");
    case OrderStatusEnum.DRAFT:
      return tolgee.t("badgeStatus.order_DRAFT");
    case OrderStatusEnum.IN_PROGRESS:
      return tolgee.t("badgeStatus.order_IN_PROGRESS");
    default:
      return "";
  }
};
